import React from 'react'
import LiveEditor from './LiveEditor'
import LiveDiscuss from './LiveDiscuss'
import "./index.css"
import Header4 from '../../Header/Header4'
import {connect} from 'react-redux'
import Axios from "axios";

class LiveManager extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            userId: "",
            userName: "",

            liveId: "",
            pullPath: "",
            liveName: "",//直播间名称
            liveCover: "./images/icon-avatar.png",//直播间封面
            hostId: "",
            liveNotice: "",
            groupId: "",

            liveStatus: false,
            isLoaded: false,
        }
    }

    async componentWillMount() {
        if (this.props.user.userId && (this.state.userId !== this.props.user.userId)) {
            await this.setState({userId: this.props.user.userId, userName: this.props.user.userName});//获取用户信息

            let data = await this.searchLiveRoom();//获取已有的直播间信息
            console.log("LiveManager:", data);
            if (!data && typeof (data) !== undefined && data !== 0) {
                await this.setState({isLoaded: true});
            } else {//如果已经有直播间
                await this.setState({
                    isLoaded: true, liveStatus: true,
                    liveId: data.liveId, pullPath: data.pullPath, liveName: data.liveName,
                    liveCover: data.liveCover, hostId: data.hostId, liveNotice: data.liveNotice, groupId: data.groupId
                });
            }
        }
    }

    async componentWillReceiveProps(props) {
        if (props.user.userId && (this.state.userId !== props.user.userId)) {
            await this.setState({userId: props.user.userId, userName: props.user.userName});//获取用户信息

            let data = await this.searchLiveRoom();//获取已有的直播间信息
            console.log("LiveManager:", data);
            if (!data && typeof (data) !== undefined && data !== 0) {
                await this.setState({isLoaded: true});
            } else {//如果已经有直播间
                await this.setState({
                    isLoaded: true, liveStatus: true,
                    liveId: data.liveId, pullPath: data.pullPath, liveName: data.liveName,
                    liveCover: data.liveCover, hostId: data.hostId, liveNotice: data.liveNotice, groupId: data.groupId
                });
            }
        }
    }

    /**
     * 查看是否有已经有直播间
     * @returns {*}
     * liveId\pullPath\liveName\liveCover\hostId\liveNotice\groupId
     */
    searchLiveRoom = async () => {
        const apiRoot = `${global.url.live}/live/search`;
        let data;
        await Axios.get(apiRoot).then(res => {
            data = res.data.payload;
        });
        return data;
    }

    render() {
        const {
            userId, userName,
            liveId, pullPath, liveName, liveCover, hostId, liveNotice, groupId,
            liveStatus, isLoaded
        } = this.state;

        if (!isLoaded) {
            return (
                <React.Fragment>
                    <Header4></Header4>
                    <div className="live-manager">
                        <div className="live-manager-layout">
                            <div className="live-manager-layout-content"/>
                        </div>
                    </div>
                </React.Fragment>
            )
        }

        if (isLoaded) {
            return (
                <React.Fragment>
                    <Header4></Header4>
                    <div className="live-manager">
                        <div className="live-manager-layout">
                            <div className="live-manager-layout-content">
                                <div className="live-manager_main_container">
                                    <div className="live-manager-layout-left">
                                        <LiveEditor userId={userId} userName={userName}
                                                    liveId={liveId} pullPath={pullPath} liveName={liveName}
                                                    liveCover={liveCover} hostId={hostId} liveNotice={liveNotice}
                                                    groupId={groupId}
                                                    liveStatus={liveStatus}
                                                    setLiveInfo={(liveStatus, liveId, groupId) => this.setState({
                                                        liveStatus: liveStatus,
                                                        liveId: liveId,
                                                        groupId: groupId
                                                    })}/>
                                    </div>
                                    <div className="live-manager-layout-right">
                                        <LiveDiscuss userId={userId} userName={userName}
                                                     liveId={liveId} pullPath={pullPath} liveName={liveName}
                                                     liveCover={liveCover} hostId={hostId} liveNotice={liveNotice}
                                                     groupId={groupId}
                                                     liveStatus={liveStatus}/>
                                    </div>
                                </div>
                            </div>
                            {/*<Navigator/>*/}
                        </div>
                    </div>
                </React.Fragment>
            )
        }
    }
}

const mapState = (state) => ({ //返回值对应的是组件的props
    user: state.userReducer.get('user').toJS()
})
const mapDispatch = (dispatch, ownProps) => ({})
export default connect(mapState, mapDispatch)(LiveManager);